import { guidesValidate } from '../../application/dtos/guides_validate';

export class guidesEntity {
    constructor({ data, meta }){
        this.data = data;
        this.meta = meta;
    }

    isValid() {
        return guidesValidate(this);
    }
}